import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getIssuesForSupport(filters) {
    const query = qs.stringify(filters, { skipNulls: true });

    const resource = ['/v3/issues', query].filter(Boolean).join('?');

    const response = await axiosPrivate.get(resource);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getIssuesForPharmacist(pharmacyId, filters) {
    const query = qs.stringify(filters, { skipNulls: true });

    const resource = [`/v3/pharmacies/${pharmacyId}/issues`, query].filter(Boolean).join('?');

    const response = await axiosPrivate.get(resource);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getIssueById(issueId) {
    const resource = `/v3/issues/${issueId}`;

    const response = await axiosPrivate.get(resource);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getIssueResolutionTypes() {
    const resource = '/v3/issues/resolution-types';

    const response = await axiosPrivate.get(resource);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async closeIssue(issueId, data) {
    if (!data.issueResolutionTypeId) throw new Error('Resolution type is required');
    if (!data.resolutionComment) throw new Error('Note to patient is required');

    const resource = `/v3/issues/${issueId}/close`;

    const response = await axiosPrivate.patch(resource, data);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async assignIssue(issueId, data) {
    const resource = `/v3/issues/${issueId}/assign`;

    const response = await axiosPrivate.patch(resource, data);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getIssueOrder(issueId) {
    const resource = `/v3/issues/${issueId}/order`;

    const response = await axiosPrivate.get(resource);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
